import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["mainTitle", "helperText", "subTitle", "twStyle", "orientation"],
    _excluded2 = ["options", "onChange", "testId", "orientation"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { memo, useMemo } from 'react';
import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react';
import { HelperTextRElement, SkeletonLoading, TextInput, Title } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// type BgColor = 'white' | 'primary';
// type Spacing = 'small' | 'medium' | 'large';
export var RadioGroup = /*#__PURE__*/memo(function (props) {
  var mainTitle = props.mainTitle,
      helperText = props.helperText,
      subTitle = props.subTitle,
      twStyle = props.twStyle,
      orientation = props.orientation,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [mainTitle && /*#__PURE__*/_jsx(Title, {
      content: mainTitle,
      isCenter: true,
      fontSize: "extraLarge",
      fontWeight: "semibold"
    }), subTitle && /*#__PURE__*/_jsx(Title, {
      content: subTitle,
      textColor: "gray",
      isCenter: true,
      fontSize: "small",
      fontWeight: "normal"
    }), /*#__PURE__*/_jsxs(RadioGroupWrapper, {
      orientation: orientation,
      twStyle: twStyle,
      children: [/*#__PURE__*/_jsx(RadioComponent, _objectSpread({
        orientation: orientation
      }, rest)), helperText && /*#__PURE__*/_jsx(HelperTextRElement, {
        helperText: helperText
      })]
    })]
  });
});

var RadioGroupWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "formradio-group__RadioGroupWrapper",
  componentId: "sc-4s0ys4-0"
})(["", " ", " ", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "width": "100%",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "maxHeight": "20rem",
    "overflowY": "auto"
  }
}, function (_ref) {
  var orientation = _ref.orientation;
  return orientation === 'horizontal' ? {
    "maxWidth": "max-content"
  } : {};
}, function (_ref2) {
  var twStyle = _ref2.twStyle;
  return twStyle;
});

var RadioComponent = /*#__PURE__*/memo(function (props) {
  var options = props.options,
      onChange = props.onChange,
      testId = props.testId,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/_jsx(HeadlessRadioGroup, _objectSpread(_objectSpread({
    className: orientation === 'horizontal' ? 'flex flex-row flex-wrap gap-3' : 'flex flex-col gap-3',
    as: "ul",
    "data-cy": testId,
    onChange: onChange
  }, rest), {}, {
    children: options ? options.map(function (option, index) {
      return /*#__PURE__*/_jsx(Radio, _objectSpread({
        orientation: orientation,
        option: option,
        index: index
      }, rest), option.id + index);
    }) : /*#__PURE__*/_jsx(SkeletonLoading, {
      variant: "text"
    })
  }));
});
export var Radio = function Radio(_ref3) {
  var option = _ref3.option,
      index = _ref3.index,
      value = _ref3.value,
      _ref3$returnKey = _ref3.returnKey,
      returnKey = _ref3$returnKey === void 0 ? 'id' : _ref3$returnKey,
      borderless = _ref3.borderless,
      showVerticalLineBelow = _ref3.showVerticalLineBelow,
      id = _ref3.id,
      inlineTextInputProps = _ref3.inlineTextInputProps,
      testId = _ref3.testId,
      orientation = _ref3.orientation,
      customOptionStyle = _ref3.customOptionStyle;
  var returnKeyWithType = returnKey;
  var optionValue = option[returnKeyWithType];
  var checked = useMemo(function () {
    return value === optionValue;
  }, [optionValue, value]);
  var returnId = useMemo(function () {
    return returnKeyWithType && optionValue ? "".concat(optionValue === null || optionValue === void 0 ? void 0 : optionValue.toString(), "-").concat(id) : option.id;
  }, [id, option.id, optionValue, returnKeyWithType]);
  var hasInput = useMemo(function () {
    return value === 'other' && option.id === 'other';
  }, [option.id, value]);
  var otherOptionInput = useMemo(function () {
    if (inlineTextInputProps && hasInput) return /*#__PURE__*/_jsx(TextInput, _objectSpread({
      type: "text",
      name: "other"
    }, inlineTextInputProps));else return null;
  }, [hasInput, inlineTextInputProps]);
  return /*#__PURE__*/_jsx(HeadlessRadioGroup.Option, {
    "data-cy": testId || "".concat(option.id, "-").concat(id),
    onKeyDown: function onKeyDown(e) {
      if (value === 'other') e.stopPropagation();
    },
    value: optionValue,
    id: returnId,
    as: "li",
    className: "min-w-fit",
    disabled: option.disabled,
    children: function children(_ref4) {
      var active = _ref4.active,
          disabled = _ref4.disabled;
      return /*#__PURE__*/_jsxs(StyledRadioOption, {
        id: "radiogroup-StyledOption-".concat(option.label),
        showVerticalLineBelow: showVerticalLineBelow,
        borderless: borderless,
        active: active,
        checked: checked,
        hasInput: hasInput,
        orientation: orientation,
        disabled: disabled,
        customOptionStyle: customOptionStyle,
        children: [/*#__PURE__*/_jsx(SelectIcon, {
          checked: checked
        }), /*#__PURE__*/_jsxs(_StyledDiv2, {
          children: [/*#__PURE__*/_jsx(HeadlessRadioGroup.Label, {
            id: "radiogroup-label-".concat(option.label),
            className: "font-medium text-base cursor-pointer leading-4",
            children: option.label
          }), otherOptionInput]
        })]
      });
    }
  }, option.id + index);
};

var StyledRadioOption = /*#__PURE__*/_styled.div.withConfig({
  displayName: "formradio-group__StyledRadioOption",
  componentId: "sc-4s0ys4-1"
})(["", " ", " ", ";", " ", ";", ";", " ", " ", ""], {
  "width": "100%"
}, {
  "display": "flex",
  "minWidth": "12rem",
  "maxWidth": "28rem",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.75rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))",
  "paddingTop": "0.563rem",
  "paddingBottom": "0.563rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
}, function (_ref5) {
  var checked = _ref5.checked;
  return checked ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  } : {};
}, function (_ref6) {
  var borderless = _ref6.borderless;
  return borderless ? {
    "borderStyle": "none"
  } : {};
}, function (_ref7) {
  var showVerticalLineBelow = _ref7.showVerticalLineBelow;
  return showVerticalLineBelow ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
    "paddingLeft": "0px",
    "paddingRight": "0px"
  } : {};
}, function (_ref8) {
  var hasInput = _ref8.hasInput;
  return hasInput ? {
    "alignItems": "flex-start"
  } : {};
}, function (_ref9) {
  var orientation = _ref9.orientation;
  return orientation === 'horizontal' ? {
    "minWidth": "fit-content",
    "justifyContent": "center"
  } : {};
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? {
    "pointerEvents": "none",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  } : {};
}, function (_ref11) {
  var customOptionStyle = _ref11.customOptionStyle;
  return customOptionStyle;
});

var SelectIcon = /*#__PURE__*/_styled.span.withConfig({
  displayName: "formradio-group__SelectIcon",
  componentId: "sc-4s0ys4-2"
})(["", " ", " ", ""], {
  "borderRadius": "9999px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))",
  "padding": "0.5rem"
}, function (_ref12) {
  var checked = _ref12.checked;
  return checked && {
    "borderWidth": "4px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))",
    "padding": "0.25rem"
  };
}, function (_ref13) {
  var checked = _ref13.checked;
  return !checked && {
    ":hover": {
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(240 235 248 / var(--tw-ring-opacity))"
    }
  };
});

export default RadioGroup; // ${({ bgColor = 'primary' }) => ({ white: tw`bg-white`, primary: tw`bg-primary-50` }[bgColor])}
// ${({ spacing = 'medium' }) => ({ small: tw`py-2 px-2 text-sm`, medium: tw`py-4 px-2 text-base`, large: tw`py-6 px-4 text-lg` }[spacing])}

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formradio-group___StyledDiv",
  componentId: "sc-4s0ys4-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formradio-group___StyledDiv2",
  componentId: "sc-4s0ys4-4"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});